import React from 'react'
import { useTranslation } from '../../../hooks/useTranslation'
import { useExercise } from '../ExerciseProvider'

const DiscoverYourConsultingNicheConclusion = () => {
  const { formattedExerciseName } = useExercise()
  const { t } = useTranslation(formattedExerciseName)
  const summaryItems = t('summary_items', { returnObjects: true })
  const summaryText = t('summary_text', { returnObjects: true })

  return (
    <div className="flex flex-col gap-4">
      <div>
        {summaryItems.map((item, idx) => (
          <p key={`summary-item-${idx}`}>
            <span className="font-bold">{item.title}: </span>
            {item.description}
          </p>
        ))}
      </div>
      <div>
        {summaryText.map((item, idx) => (
          <LinkifiedText key={`summary-text-${idx}`} item={item} />
        ))}
      </div>
    </div>
  )
}
export default DiscoverYourConsultingNicheConclusion

const LinkifiedText = ({ item }) => {
  const { text, klass, link_text, link_url } = item
  const textParts = text.split('[link]')
  if (textParts.length < 2) return <p className={klass}>{text}</p>
  return (
    <p className={klass}>
      {textParts[0]}
      <a href={link_url}>{link_text}</a>
      {textParts[1]}
    </p>
  )
}
